class DeviceStatisticCollection extends App.Collections.BaseCollection {
    url = 'DeviceStatistic';
    model = App.Models.DeviceStatistic;
}

App.Collections.DeviceStatistics = DeviceStatisticCollection;